import { toRefs, computed } from 'vue'
import { useStore } from 'vuex'

// 判断用户是否有某个权限
const useUserPermissions = (code) => {
  const store = useStore()
  const { userInfo } = toRefs(store.state)

  return computed(() => {
    return userInfo.value.functional_permission?.find?.((item) => item.code === code)
  })
}

export default useUserPermissions
